module.exports = __webpack_public_path__ + "img/small-immigration.0cb76cc1.jpg";